import React, { FC } from 'react';
import { Box, Grid } from '@material-ui/core';
import classnames from 'classnames';
import Header from './Header';
import { MenuCategories } from '../../propTypes/builtMenuTypes';
import styles from './Layout.styles';

interface LayoutProps {
  menuLayoutStyling?: boolean;
  hideHeader?: boolean;
  displayLogo?: boolean;
  currentPage: string;
  fullHeightContent?: boolean;
  orderConfirmationStyling?: boolean;
  onClickViewBill?: () => void | undefined;
  onClickBackArrow?: () => void | undefined;
  displayFaq?: boolean;
  menuCategories?: MenuCategories;
  paymentPage?: boolean;
  billLayoutStyling?: boolean;
  displayMenuNavigation?: boolean;
  flexLayout?: boolean;
  variant?: string;
  className?: string;
  layoutClassName?: string;
  displayLeaveTable?: boolean;
}

const Layout: FC<LayoutProps> = ({
  menuLayoutStyling = false,
  hideHeader = false,
  displayLogo = false,
  currentPage,
  fullHeightContent = false,
  orderConfirmationStyling = false,
  onClickViewBill = undefined,
  onClickBackArrow = undefined,
  displayFaq = false,
  menuCategories = [],
  paymentPage = false,
  billLayoutStyling = false,
  displayMenuNavigation = false,
  flexLayout = false,
  displayLeaveTable = false,
  variant,
  className,
  layoutClassName,
  children,
  ...props
}: any) => {
  const classes = styles();

  const layoutClasses = classnames(layoutClassName, {
    [classes.alternativeLayout]: menuLayoutStyling,
    [classes.layout]: !menuLayoutStyling,
    [classes.fullHeightContent]: fullHeightContent,
    [classes.orderConfirmationStyling]: orderConfirmationStyling,
    [classes.minViewHeight]: !billLayoutStyling,
    [classes.flexLayout]: flexLayout,
  });

  const paymentPageClass = classnames({
    [classes.container]: paymentPage,
  });

  const layoutContainerHeight = menuLayoutStyling ? 'auto' : '100%';

  return (
    <Box
      height={layoutContainerHeight}
      className={`${className} ${paymentPageClass}`}
      variant={variant}
      {...props}
    >
      {!hideHeader && (
        <header aria-label="Header" data-testid="header" className={classes.header}>
          <nav>
            <Header
              displayLogo={displayLogo}
              currentPage={currentPage}
              displayFaq={displayFaq}
              onClickViewBill={onClickViewBill}
              onClickBackArrow={onClickBackArrow}
              menuCategories={menuCategories}
              displayMenuNavigation={displayMenuNavigation}
              displayLeaveTable={displayLeaveTable}
            />
          </nav>
        </header>
      )}
      <Grid container direction="column" className={layoutClasses}>
        {children}
      </Grid>
    </Box>
  );
};

export default Layout;
